import React, { useEffect, useContext, useState, useRef } from "react";
import Stomp from "stompjs";
import * as conf from "../config/config";
//https://b-1e48808f-d687-4faf-884d-43d58b310371-2.mq.us-east-1.amazonaws.com
/*
const url =  "wss://b-1e48808f-d687-4faf-884d-43d58b310371-2.mq.us-east-1.amazonaws.com:61619";
const user = "sistemas";
const pass = "f4By4XqB8kYt";
*/
/*
const url =  "wss://b-1e48808f-d687-4faf-884d-43d58b310371-2.mq.us-east-1.amazonaws.com:61619";
const user = "telefonia";
const pass = "W4B7Sd9OlFb1";
*/
const url1 =  "wss://"+conf.activeMq01;
const url2 =  "wss://"+conf.activeMq02;
const user = "WEBSOCKET";
const pass = "w3bs0k3t2024";

const PbxMensageria =({ topics, obtenerMensaje })=> {
  const [mensajeEntrante, setMensajeEntrante] = useState(null);

  // Cliente STOMP por instancia (no compartido a nivel de módulo),
  // así TelefonoSip y PbxDash pueden coexistir sin pisarse la conexión.
  const clientRef = useRef(null);
  // URL activa por instancia (para el failover entre activeMq01/activeMq02).
  const urlRef = useRef(url1);

  // Clave estable basada en el CONTENIDO de topics, no en su referencia.
  // El padre pasa un array literal inline (nuevo en cada render), así que
  // depender de `topics` reconectaba el websocket en cada render.
  const topicsKey = (topics || []).join(",");

  useEffect(() => {
    if(topics.length){console.log("topics: ", topics);
      console.log("conectar al websocket: ");
      conectar();
    }
    // Limpieza: desconectar el cliente anterior antes de reconectar (o al desmontar)
    // para no acumular conexiones en paralelo ni dejar sockets colgando.
    return () => {
      const client = clientRef.current;
      if (client) {
        try {
          if (client.connected) {
            client.disconnect(() => {});
          } else if (client.ws) {
            client.ws.close();
          }
        } catch (e) {
          console.log("Error al desconectar cliente websocket previo:", e);
        }
        clientRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicsKey]);

  const conectar = () => {
    // Referencia local: el callback debe suscribirse sobre ESTE cliente,
    // no sobre clientRef.current, que puede haberse reasignado a otra
    // conexión aún en estado CONNECTING (evita el InvalidStateError).
    const clienteActual = Stomp.client(urlRef.current);
    clienteActual.heartbeat = { incoming: 20000, outgoing: 20000, };
    clienteActual.debug = () => {};
    clienteActual.reconnect_delay = 5000;
    clientRef.current = clienteActual;
    clienteActual.connect(
      user,
      pass,
      (frame) => {
        //Conect callback
        if (topics && topics.length) {
          for (let t of topics) {
            clienteActual.subscribe(t, (message) => {
              if (message.body.includes("{")) {
                setMensajeEntrante(message.body);
              }
            });
          }
        }
      },
      (err) => {
        urlRef.current = (urlRef.current === url1) ? url2 : url1;
        //error useCallback
        console.log(err);
        if (typeof err === "string" && err.toUpperCase().includes("LOST CONNECTION")) {
          setTimeout(() => {
            conectar();
          }, 5000);
          //alert(err);
        }
      }
    );
  }

  useEffect(() => {
    if(mensajeEntrante){
      //console.log("mensajeEntrante: ", mensajeEntrante);
      obtenerMensaje(JSON.parse(mensajeEntrante));
    }
  }, [mensajeEntrante]);

/*
  const sendMessage = (topic, msg, data) => {
    client.send(topic, {}, msg);
  };
  */

  return <></>;
}
export default PbxMensageria;
